module.exports = __webpack_public_path__ + "img/6.bb029d7e.png";